import React from "react";
import { useMyHrUserRolesDataByContract } from "my-hr/hooks";
import {
  OcSidebarBackMenu,
  OcSidebarCollapse,
  OcSidebarGroup,
  OcSidebarItem,
  OcSidebarSubmenu,
} from "oc/components";
import { SidebarMenuItem } from "oc/configs/constants";
import { BadgeType } from "oc/components/sidebar/badge-registry";
import { useOcCurrentUserState } from "oc/hooks";
import { IconifyIcon } from "@iconify/react";

interface SidebarItem {
  id: string;
  label: string;
  translation?: string;
  type: "backMenu" | "group" | "item" | "collapse" | "submenu";
  roles?: string[];
  notAllowedRoles?: string[];
  targetMenu?: string;
  badge?: BadgeType;
  icon?: React.ReactNode;
  path?: string;
  narrowMenuIcon?: string | IconifyIcon;
  children?: SidebarItem[];
}

interface OcSidebarSelectorProps {
  item: SidebarItem | SidebarMenuItem;
  onMenuChange: (menuId: string) => void;
  onMenuItemChange: (menuItemId: string) => void;
  activeMenuItem: string;
  narrowMenu: boolean;
  onChangeTemporaryDrawer?: () => void;
  narrowMenuOpened: boolean;
}

export const OcSidebarSelector: React.FC<OcSidebarSelectorProps> = ({
  item,
  onMenuChange,
  onMenuItemChange,
  activeMenuItem,
  narrowMenu,
  onChangeTemporaryDrawer,
  narrowMenuOpened,
}) => {
  let { contractCode } = useOcCurrentUserState();
  const { hasRole } = useMyHrUserRolesDataByContract({
    contract: contractCode,
  });

  if (!hasRole(item.roles ?? [], item.notAllowedRoles ?? [])) return null;

  if (item.type === "backMenu")
    return (
      <OcSidebarBackMenu
        id={item.id}
        label={item.label}
        translation={item.translation || ""}
        onMenuChange={onMenuChange}
        narrowMenu={narrowMenu}
        targetMenu={item.targetMenu || ""}
      />
    );

  if (item.type === "group")
    return (
      <OcSidebarGroup
        id={item.id}
        label={item.label}
        translation={item.translation || ""}
        narrowMenu={narrowMenu}
        narrowMenuOpened={narrowMenuOpened}
      />
    );
  if (item.type === "item")
    return (
      <OcSidebarItem
        badge={item.badge}
        icon={item.icon}
        id={item.id}
        label={item.label}
        narrowMenu={narrowMenu}
        narrowMenuIcon={item.narrowMenuIcon}
        narrowMenuOpened={narrowMenuOpened}
        onChangeTemporaryDrawer={onChangeTemporaryDrawer}
        onMenuChange={onMenuItemChange}
        path={item.path || ""}
        translation={item.translation}
      />
    );
  if (item.type === "collapse")
    return (
      <OcSidebarCollapse
        id={item.id}
        badge={item.badge}
        icon={item.icon}
        label={item.label}
        activeMenuItem={activeMenuItem}
        onMenuItemChange={onMenuItemChange}
        onMenuChange={onMenuChange}
        narrowMenu={narrowMenu}
        onChangeTemporaryDrawer={onChangeTemporaryDrawer}
        narrowMenuOpened={narrowMenuOpened}
        translation={item.translation}
      >
        {item.children ?? []}
      </OcSidebarCollapse>
    );
  if (item.type === "submenu")
    return (
      <OcSidebarSubmenu
        id={item.id}
        label={item.label}
        translation={item.translation || ""}
        onMenuChange={() => onMenuChange(item.id)}
        narrowMenuOpened={narrowMenuOpened}
      />
    );
  return null;
};

export default OcSidebarSelector;
